  
import Home from "./pages/home"; 
import DataScienceCourseBangalore from "./pages/data-science-course-training-in-bangalore";
import DataScienceCoursePune from "./pages/Data-Science-Course-in-Pune";
import React, { Component, useEffect } from "react"; 
import { Route, Routes, useLocation } from "react-router-dom";

import "./App.css";

{/*import AdvanceAIMLprogram from './pages/advance-ai-ml-program';
import DataScienceCoursePune from "./pages/Data-Science-Course-in-Pune";
import DataScienceCourseBangalore from "./pages/data-science-course-training-in-bangalore";
import AdvanceDataScienceMLProgram from './pages/advance-data-Science-ml-program';
import MasterdataScienceaiprogram from './pages/AI-Fundamental-for-Non-Data-Scientist';
import DataScienceCourseForManagers from './pages/Data-Science-Course-For-Managers';
import PostGraduateProgramForDataScience from './pages/Post-Graduate-Program-For-Data-Science';
import IntroductiontoDataAnalytics from './pages/Introduction-to-Data-Analytics';
import AppliedDataSciencewithPython from './pages/Applied-Data-Science-with-Python';
import AIandMachineLearningFundamentals from './pages/AI-and-Machine-Learning-Fundamentals';
import MathematicsForMachineLearningandDataScience from './pages/Mathematics-For-Machine-Learning-and-Data-Science';

import MTechinDataScienceandMachineLearning from './pages/MTech-in-Data Science-and-Machine-Learning';

import MSinDataScience from './pages/MS-in-Data-Science';

import PGPrograminDataScienceandBusinessAnalytics from './pages/PG-Program-in-Data-Science-and-Business-Analytics';

import DataScienceCourseHydrabad from './pages/home-Hyderabad';
import AIFundamentalforNonDataScientist from './pages/AI-Fundamental-for-Non-Data-Scientist';

import MasterinDataSciencebyMIT from './pages/Master-in-Data-Science-by-MIT';

import PracticalDecisionMakinginDataScience from './pages/Practical-Decision-Making-in-Data-Science';


import HomeHyderabad from './pages/home-Hyderabad';




import BasicsIntroductiontoDataScience from './pages/Post-Graduate-Program-For-Data-Science';

import PGPinDataScienceandEngineering from './pages/PGP-in-Data-Science-and-Engineering';




import DataScienceForFreshers from './pages/Data-Science-For-Freshers';


import DataScienceCourseAhmedabad from './pages/home-Ahmedabad';
import DataScienceCourseBhilai from './pages/home-Bhilai';
import DataScienceCourseBhopal from './pages/home-Bhopal';
import DataScienceCourseBhubaneshwar from './pages/home-Bhubaneshwar';
import DataScienceCourseBoston from './pages/home-Boston';
import DataScienceCourseChandigarh from './pages/home-Chandigarh';
import DataScienceCourseChennai from './pages/home-Chennai';
import DataScienceCourseChicago from './pages/home-Chicago';
import DataScienceCourseCochin from './pages/home-Cochin';
import DataScienceCourseCoimbatore from './pages/home-Coimbatore';
import DataScienceCourseDallas from './pages/home-Dallas';
import DataScienceCourseDehradun from './pages/home-Dehradun';
import DataScienceCourseDelhi from './pages/home-Delhi';
import DataScienceCourseDubai from './pages/home-dubai';
import DataScienceCourseDurban from './pages/home-Durban';
import DataScienceCourseFaridabad from './pages/home-Faridabad';
import DataScienceCourseGhaziabad from './pages/home-Ghaziabad';
import DataScienceCourseGorakhpur from './pages/home-Gorakhpur';
import DataScienceCourseGuntur from './pages/home-Guntur';
import DataScienceCourseGurgaon from './pages/home-Gurgaon';
import DataScienceCourseGuwahati from './pages/home-Guwahati';
import DataScienceCourseHongKong from './pages/home-HongKong';
import DataScienceCourseHyderabad from './pages/home-Hyderabad';
import DataScienceCourseJaipur from './pages/home-Jaipur';
import DataScienceCourseJohannesburg from './pages/home-Johannesburg';
import DataScienceCourseKanpur from './pages/home-Kanpur';
import DataScienceCourseKolkata from './pages/home-Kolkata';
import DataScienceCourseLosAngeles from './pages/home-LosAngeles';
import DataScienceCourseLucknow from './pages/home-Lucknow';
import DataScienceCourseMadurai from './pages/home-Madurai';
import DataScienceCourseMiami from './pages/home-Miami';
import DataScienceCourseMumbai from './pages/home-mumbai';
import DataScienceCourseMysore from './pages/home-Mysore';
import DataScienceCourseNagpur from './pages/home-nagpur';
import DataScienceCourseNoida from './pages/home-Noida';
import DataScienceCoursePatna from './pages/home-Patna';
import DataScienceCoursePondicherry from './pages/home-Pondicherry';
import DataScienceCourseRanchi from './pages/home-Ranchi';
import DataScienceCourseSeattle from './pages/home-Seattle';
import DataScienceCourseShimoga from './pages/home-Shimoga';
import DataScienceCourseSurat from './pages/home-Surat';
import DataScienceCourseThane from './pages/home-Trichur';
import DataScienceCourseThiruvananthapuram from './pages/home-Thiruvananthapuram';
import DataScienceCourseTiruchchirappalli from './pages/home-Tiruchchirappalli';
import DataScienceCourseTirupati from './pages/home-Tirupati';
import DataScienceCourseToronto from './pages/home-Toronto';
import DataScienceCourseTrichur from './pages/home-Thane';
import DataScienceCourseVadodara from './pages/home-Vadodara';
import DataScienceCourseVisakhapatnam from './pages/home-Visakhapatnam';
import DataScienceCourseWarangal from './pages/home-Warangal';
import DataScienceCourseWashington from './pages/home-Washington';


import DataScienceCourseMountainView from './pages/home-MountainView';
import DataScienceCourseAshburn from './pages/home-Ashburn';
import DataScienceCourseAustin from './pages/home-Austin';
import DataScienceCourseCharlotte from './pages/home-Charlotte';
import DataScienceCourseSanDiego from './pages/home-SanDiego';
import DataScienceCourseIrving from './pages/home-Irving';
import DataScienceCourseColumbus from './pages/home-Columbus';
import DataScienceCourseSunnyvale from './pages/home-Sunnyvale';
import DataScienceCourseFremont from './pages/home-Fremont';
import DataScienceCourseDenver from './pages/home-Denver';
import DataScienceCoursePhiladelphia from './pages/home-Philadelphia';
import DataScienceCourseVijayawada from './pages/home-Vijayawada';
import DataScienceCourseIreland from './pages/home-Ireland';
import DataScienceCourseKerala from './pages/home-Kerala';
import DataScienceCourseTamilNadu from './pages/home-Tamil Nadu';
import DataScienceCourseLudhiana from './pages/home-Ludhiana';
import DataScienceCourseAbuDhabi from './pages/home-AbuDhabijs';
import DataScienceCourseErnakulam from './pages/home-Ernakulam';
import DataScienceCourseKottayam from './pages/home-Kottayam';
import DataScienceCourseKhammam from './pages/home-Khammam';
import DataScienceCourseJacksonville from './pages/home-Jacksonville';
import DataScienceCourseNewark from './pages/home-Newark';
import DataScienceCoursePittsburgh from './pages/home-Pittsburgh';
import DataScienceCourseRaleigh from './pages/home-Raleigh';
import DataScienceCourseSalem from './pages/home-Salem';
import DataScienceCourseSarasota from './pages/home-Sarasota';
import DataScienceCourseTacoma from './pages/home-Tacoma';
import DataScienceCourseTampa from './pages/home-Tampa';
import DataScienceCourseAbuja from './pages/home-Abuja';
import DataScienceCourseLagos from './pages/home-Lagos';
import DataScienceCourseManila from './pages/home-Manila';
import DataScienceCourseCapeTown from './pages/home-CapeTown';
import DataScienceCourseCalgary from './pages/home-Calgary';
import DataScienceCourseMontreal from './pages/home-Montreal';
import DataScienceCourseVancouver from './pages/home-Vancouver';*/}


function App() {

  // const location = useLocation();

  // useEffect(() => {
  //   if (location.pathname !== '/' && location.pathname.endsWith('/')) {
  //     const newPath = `/data-science-course-one${location.pathname.slice(0, -1)}`;
  //     window.location.replace(newPath);
  //     console.log(newPath);
  //   }
  //   console.log(location);
  // }, [location]);

  return (
    <Routes>
      <Route exact path="" element={<Home />} />
      {/*<Route path='/Advance-AI-ML-program' element={<AdvanceAIMLprogram/>}/>
      <Route path='/Advance-Data-Science-ML-Program' element={<AdvanceDataScienceMLProgram/>}/>
      <Route path='/Master-data-Science-ai-program' element={<MasterdataScienceaiprogram/>}/>


      <Route path='/AI-and-Machine-Learning-Fundamentals' element={<AIandMachineLearningFundamentals/>}/>
      <Route path='/AI-Fundamental-for-Non-Data-Scientist' element={<AIFundamentalforNonDataScientist/>}/>
      <Route path='/Applied-Data-Science-with-Python' element={<AppliedDataSciencewithPython/>}/>

      <Route path='/Basics-Introduction-to-Data-Science' element={<BasicsIntroductiontoDataScience/>}/>
      <Route path='/Data-Science-Course-For-Managers' element={<DataScienceCourseForManagers/>}/>
      <Route path='/Data-Science-For-Freshers' element={<DataScienceForFreshers/>}/>

      <Route
        path="/Data-Science-Course-in-Pune"
        element={<DataScienceCoursePune/>}
      />

<Route
        path="/data-science-course-training-in-bangalore"
        element={<DataScienceCourseBangalore/>}
      />
      
      <Route path='/Introduction-to-Data-Analytics' element={<IntroductiontoDataAnalytics/>}/>
      


      <Route path='/Mathematics-For-Machine-Learning-and-Data-Science' element={<MathematicsForMachineLearningandDataScience/>}/>
      <Route path='/Post-Graduate-Program-For-Data-Science' element={<PostGraduateProgramForDataScience/>}/>
      <Route path='/PG-Program-in-Data-Science-and-Business-Analytics' element={<PGPrograminDataScienceandBusinessAnalytics/>}/>
      <Route path='/MS-in-Data-Science' element={<MSinDataScience/>}/>
      <Route path='/MTech-in-Data-Science-and-Machine-Learning' element={<MTechinDataScienceandMachineLearning/>}/>
      <Route path='/Master-in-Data-Science-by-MIT' element={<MasterinDataSciencebyMIT/>}/>
      <Route path='/Practical-Decision-Making-in-Data-Science' element={<PracticalDecisionMakinginDataScience/>}/>
      <Route path='/PGP-in-Data-Science-and-Engineering' element={<PGPinDataScienceandEngineering/>}/>


      <Route path="/Data-Science-Course-Hydrabad" element={<DataScienceCourseHydrabad/>}></Route>

      <Route path="/Data-Science-Course-Ahmedabad" element={<DataScienceCourseAhmedabad/>}></Route>
      
      <Route path="/Data-Science-Course-Bhilai" element={<DataScienceCourseBhilai/>}></Route>
      
      <Route path="/Data-Science-Course-Bhopal" element={<DataScienceCourseBhopal/>}></Route>
      
      <Route path="/Data-Science-Course-Bhubaneshwar" element={<DataScienceCourseBhubaneshwar/>}></Route>

      <Route path="/Data-Science-Course-Boston" element={<DataScienceCourseBoston/>}></Route>

      <Route path="/Data-Science-Course-Chandigarh" element={<DataScienceCourseChandigarh/>}></Route>

      <Route path="/Data-Science-Course-Chennai" element={<DataScienceCourseChennai/>}></Route>

      <Route path="/Data-Science-Course-Chicago" element={<DataScienceCourseChicago/>}></Route>

      <Route path="/Data-Science-Course-Cochin" element={<DataScienceCourseCochin/>}></Route>

      <Route path="/Data-Science-Course-Coimbatore" element={<DataScienceCourseCoimbatore/>}></Route>

      <Route path="/Data-Science-Course-Dallas" element={<DataScienceCourseDallas/>}></Route>

      <Route path="/Data-Science-Course-Dehradun" element={<DataScienceCourseDehradun/>}></Route>

      <Route path="/Data-Science-Course-Delhi" element={<DataScienceCourseDelhi/>}></Route>

      <Route path="/Data-Science-Course-Dubai" element={<DataScienceCourseDubai/>}></Route>

      <Route path="/Data-Science-Course-Durban" element={<DataScienceCourseDurban/>}></Route>

      <Route path="/Data-Science-Course-Faridabad" element={<DataScienceCourseFaridabad/>}></Route>

      <Route path="/Data-Science-Course-Ghaziabad" element={<DataScienceCourseGhaziabad/>}></Route>

      <Route path="/Data-Science-Course-Gorakhpur" element={<DataScienceCourseGorakhpur/>}></Route>

      <Route path="/Data-Science-Course-Guntur" element={<DataScienceCourseGuntur/>}></Route>

      <Route path="/Data-Science-Course-Gurgaon" element={<DataScienceCourseGurgaon/>}></Route>

      <Route path="/Data-Science-Course-Guwahati" element={<DataScienceCourseGuwahati/>}></Route>

      <Route path="/Data-Science-Course-HongKong" element={<DataScienceCourseHongKong/>}></Route>

      <Route path="/Data-Science-Course-Hyderabad" element={<DataScienceCourseHyderabad/>}></Route>

      <Route path="/Data-Science-Course-Jaipur" element={<DataScienceCourseJaipur/>}></Route>

      <Route path="/Data-Science-Course-Johannesburg" element={<DataScienceCourseJohannesburg/>}></Route>

      <Route path="/Data-Science-Course-Kanpur" element={<DataScienceCourseKanpur/>}></Route>

      <Route path="/Data-Science-Course-Khammam" element={<DataScienceCourseKhammam/>}></Route>

      <Route path="/Data-Science-Course-Kolkata" element={<DataScienceCourseKolkata/>}></Route>

      <Route path="/Data-Science-Course-LosAngeles" element={<DataScienceCourseLosAngeles/>}></Route>

      <Route path="/Data-Science-Course-Lucknow" element={<DataScienceCourseLucknow/>}></Route>

      <Route path="/Data-Science-Course-Madurai" element={<DataScienceCourseMadurai/>}></Route>

      <Route path="/Data-Science-Course-Miami" element={<DataScienceCourseMiami/>}></Route>

      <Route path="/Data-Science-Course-Mumbai" element={<DataScienceCourseMumbai/>}></Route>

      <Route path="/Data-Science-Course-Mysore" element={<DataScienceCourseMysore/>}></Route>

      <Route path="/Data-Science-Course-Nagpur" element={<DataScienceCourseNagpur/>}></Route>

      <Route path="/Data-Science-Course-Noida" element={<DataScienceCourseNoida/>}></Route>

      <Route path="/Data-Science-Course-Patna" element={<DataScienceCoursePatna/>}></Route>

      <Route path="/Data-Science-Course-Pondicherry" element={<DataScienceCoursePondicherry/>}></Route>

      <Route path="/Data-Science-Course-Ranchi" element={<DataScienceCourseRanchi/>}></Route>

      <Route path="/Data-Science-Course-Seattle" element={<DataScienceCourseSeattle/>}></Route>

      <Route path="/Data-Science-Course-Shimoga" element={<DataScienceCourseShimoga/>}></Route>

      <Route path="/Data-Science-Course-Surat" element={<DataScienceCourseSurat/>}></Route>

      <Route path="/Data-Science-Course-Thane" element={<DataScienceCourseThane/>}></Route>

      <Route path="/Data-Science-Course-Thiruvananthapuram" element={<DataScienceCourseThiruvananthapuram/>}></Route>

      <Route path="/Data-Science-Course-Tiruchchirappalli" element={<DataScienceCourseTiruchchirappalli/>}></Route>

      <Route path="/Data-Science-Course-Tirupati" element={<DataScienceCourseTirupati/>}></Route>

      <Route path="/Data-Science-Course-Toronto" element={<DataScienceCourseToronto/>}></Route>

      <Route path="/Data-Science-Course-Trichur" element={<DataScienceCourseTrichur/>}></Route>

      <Route path="/Data-Science-Course-Vadodara" element={<DataScienceCourseVadodara/>}></Route>

      <Route path="/Data-Science-Course-Visakhapatnam" element={<DataScienceCourseVisakhapatnam/>}></Route>

      <Route path="/Data-Science-Course-Warangal" element={<DataScienceCourseWarangal/>}></Route>

      <Route path="/Data-Science-Course-Washington" element={<DataScienceCourseWashington/>}></Route>

      <Route path="/Data-Science-Course-MountainView" element={<DataScienceCourseMountainView/>}></Route>

      <Route path="/Data-Science-Course-Ashburn" element={<DataScienceCourseAshburn/>}></Route>

      <Route path="/Data-Science-Course-Charlotte" element={<DataScienceCourseCharlotte/>}></Route>

      <Route path="/Data-Science-Course-Austin" element={<DataScienceCourseAustin/>}></Route>

      <Route path="/Data-Science-Course-SanDiego" element={<DataScienceCourseSanDiego/>}></Route>

      <Route path="/Data-Science-Course-Irving" element={<DataScienceCourseIrving/>}></Route>

      <Route path="/Data-Science-Course-Columbus" element={<DataScienceCourseColumbus/>}></Route>

      <Route path="/Data-Science-Course-Sunnyvale" element={<DataScienceCourseSunnyvale/>}></Route>

      <Route path="/Data-Science-Course-Fremont" element={<DataScienceCourseFremont/>}></Route>

      <Route path="/Data-Science-Course-Denver" element={<DataScienceCourseDenver/>}></Route>

      <Route path="/Data-Science-Course-Philadelphia" element={<DataScienceCoursePhiladelphia/>}></Route>

      <Route path="/Data-Science-Course-Vijayawada" element={<DataScienceCourseVijayawada/>}></Route>

      <Route path="/Data-Science-Course-Ireland" element={<DataScienceCourseIreland/>}></Route>

      <Route path="/Data-Science-Course-Kerala" element={<DataScienceCourseKerala/>}></Route>

      <Route path="/Data-Science-Course-TamilNadu" element={<DataScienceCourseTamilNadu/>}></Route>

      <Route path="/Data-Science-Course-Ludhiana" element={<DataScienceCourseLudhiana/>}></Route>

      <Route path="/Data-Science-Course-AbuDhabi" element={<DataScienceCourseAbuDhabi/>}></Route>

      <Route path="/Data-Science-Course-Ernakulam" element={<DataScienceCourseErnakulam/>}></Route>

      <Route path="/Data-Science-Course-Kottayam" element={<DataScienceCourseKottayam/>}></Route>

      <Route path="/Data-Science-Course-Jacksonville" element={<DataScienceCourseJacksonville/>}></Route>

      <Route path="/Data-Science-Course-Newark" element={<DataScienceCourseNewark/>}></Route>

      <Route path="/Data-Science-Course-Pittsburgh" element={<DataScienceCoursePittsburgh/>}></Route>

      <Route path="/Data-Science-Course-Raleigh" element={<DataScienceCourseRaleigh/>}></Route>

      <Route path="/Data-Science-Course-Salem" element={<DataScienceCourseSalem/>}></Route>

      <Route path="/Data-Science-Course-Sarasota" element={<DataScienceCourseSarasota/>}></Route>

      <Route path="/Data-Science-Course-Tacoma" element={<DataScienceCourseTacoma/>}></Route>

      <Route path="/Data-Science-Course-Tampa" element={<DataScienceCourseTampa/>}></Route>

      <Route path="/Data-Science-Course-Abuja" element={<DataScienceCourseAbuja/>}></Route>

      <Route path="/Data-Science-Course-Lagos" element={<DataScienceCourseLagos/>}></Route>

      <Route path="/Data-Science-Course-Manila" element={<DataScienceCourseManila/>}></Route>

      <Route path="/Data-Science-Course-CapeTown" element={<DataScienceCourseCapeTown/>}></Route>

      <Route path="/Data-Science-Course-Calgary" element={<DataScienceCourseCalgary/>}></Route>

      <Route path="/Data-Science-Course-Montreal" element={<DataScienceCourseMontreal/>}></Route>

      <Route path="/Data-Science-Course-Vancouver" element={<DataScienceCourseVancouver/>}></Route>*/}
     <Route
        path="/data-science-course-training-in-bangalore"
        element={<DataScienceCourseBangalore/>}
      />
       <Route
        path="/Data-Science-Course-in-Pune"
        element={<DataScienceCoursePune/>}
      />
    </Routes>
  );
}

export default App;
